import React from "react";
import { TContainerStateProps } from "../../../state/TContainerStateProps";
import { TCaseChaseModeForm } from "../../../../../domain/codecs/form/CasesChaseTransitionForm";
import { CRMCloseChaseContinueCasePopoutChaserView } from "../CRMCloseChaseContinueCasePopoutChaserView/CRMCloseChaseContinueCasePopoutChaserView";
import { CRMCloseChaseContinueCasePopoutRequestView } from "../CRMCloseChaseContinueCasePopoutRequestView/CRMCloseChaseContinueCasePopoutRequestView";
import { CRMCloseChaseContinueCasePopoutAcknowledgeView } from "../CRMCloseChaseContinueCasePopoutAcknowledgeView/CRMCloseChaseContinueCasePopoutAcknowledgeView";

export const chaseModeShowAcceptRejectForm = (chaseModeForm: TCaseChaseModeForm): boolean =>
    chaseModeForm.children.latest_chase.status === "chase"
    && chaseModeForm.children.latest_chase.acknowledged_at === null;

export const chaseModeShowAcknowledgeForm = (chaseModeForm: TCaseChaseModeForm): boolean =>
    chaseModeForm.children.latest_chase.acknowledged_at === null
    && (
        chaseModeForm.children.latest_chase.status === "workable"
        || chaseModeForm.children.latest_chase.status === "workable_rejected_chase_request"
    );

type TCRMCloseChaseContinueCasePopoutsProps = TContainerStateProps & {
    isOpen: boolean;
    onClose: () => void;
};

export const CRMCloseChaseContinueCasePopouts = (props: TCRMCloseChaseContinueCasePopoutsProps): JSX.Element => {

    const isChaserStaff = props.state.global.user.is_chaser_staff;
    const showAcceptRejectForm = chaseModeShowAcceptRejectForm(props.state.forms.chase_mode_form);
    const showAcknowledgeForm = chaseModeShowAcknowledgeForm(props.state.forms.chase_mode_form);

    return (
        <>
            {/* CHASER VIEW - ACCEPT/REJECT VIEW */}
            {props.isOpen
                && isChaserStaff
                && showAcceptRejectForm
                && !showAcknowledgeForm
                && <CRMCloseChaseContinueCasePopoutChaserView
                    {...props}
                    isOpen={props.isOpen}
                    onClose={props.onClose}
                />
            }

            {/* ACKNOWLEDGE REJECTION/ACKNOWLEDGE RETURN TO WORKABLE MODE VIEW */}
            {props.isOpen
                && !isChaserStaff
                && showAcknowledgeForm
                && !showAcceptRejectForm
                && <CRMCloseChaseContinueCasePopoutAcknowledgeView
                    {...props}
                    isOpen={props.isOpen}
                    onClose={props.onClose}
                />
            }

            {/* DEFAULT VIEW */}
            {props.isOpen
                && (
                    (isChaserStaff && !showAcceptRejectForm)
                    || (!isChaserStaff && !showAcknowledgeForm)
                )
                && <CRMCloseChaseContinueCasePopoutRequestView
                    {...props}
                    isOpen={props.isOpen}
                    onClose={props.onClose}
                />
            }
        </>
    );
};
